module.exports = __webpack_public_path__ + "img/icon-house.015920e4.svg";